import React from "react";
import { useTranslation } from "react-i18next";
import { Employee } from "../../../types/modules/admin/employee.type";
import EmployeeItem from "./EmployeeItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  employees: Employee[];
}

const EmployeesListTable: React.FC<Props> = ({ employees }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("employee_name")}</th>
            <th className="p-3 font-normal capitalize">{t("employee_phone")}</th>
            <th className="p-3 font-normal capitalize">{t("employee_role")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateAdmin]}>
              <>
              <th className="p-3 font-normal capitalize">{t("active")}</th>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
              </>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {employees.map((da, index) => (
            <tr
              key={da.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
             <EmployeeItem employee={da}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default EmployeesListTable;